import { CommonPdfContent } from 'apps/Pdf/templates/Interfaces';

export enum RequestTypes {
  'TWOFACTOR_DISABLE' = 'TWOFACTOR_DISABLE',
  'TWOFACTOR_ENABLE' = 'TWOFACTOR_ENABLE',
  'CONTRACT_TERMINATION' = 'CONTRACT_TERMINATION'
}

export interface RequestContent extends CommonPdfContent {
  type: RequestTypes;
}
